module.exports = __webpack_public_path__ + "static/flags/SV-397c10f286446e175d6587252ff26e47.gif";